import Vue from 'vue'
import Vuex from 'vuex'
import tabs from './tabs'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    tabs
  },
  state: {
    user: null,
    imageDomain: 'https://www.sqwlgz.xin:8008/'
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    clearUser(state) {
      state.user = null
    }
  },
  actions: {
    login({ commit }, user) {
      commit('setUser', user)
    },
    logout({ commit }) {
      commit('clearUser')
    }
  },
  getters: {
    getUser: state => state.user,
    getImg: state => state.imageDomain
  }
})
